/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SnapshotFilterConditions } from '../models/SnapshotFilterConditions';
import { SortSnapshotsBy } from '../models/SortSnapshotsBy';

export class ListInventorySnapshotsRequest {
  'filters'?: SnapshotFilterConditions;
  /**
  * List of sorting options. Sorting is applied in the order passed in the list. 
  */
  'sorts'?: Array<SortSnapshotsBy>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "filters",
      "baseName": "filters",
      "type": "SnapshotFilterConditions",
      "format": ""
    },
    {
      "name": "sorts",
      "baseName": "sorts",
      "type": "Array<SortSnapshotsBy>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListInventorySnapshotsRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

